import { InfoCircleOutlined } from '@ant-design/icons';
import { Button, Flex, Popover, Typography } from 'antd';
import PropTypes from 'prop-types';
import {
  getMetricProjectionFallbackMessages,
  getMetricRatioConflictMessages,
  getMetricProjectionWarningMessages,
} from '../utils/metric-projection-warnings';

const popoverStyles = {
  container: {
    maxWidth: 'calc(100vw - 32px)',
    width: 520,
  },
  content: {
    maxHeight: '50vh',
    overflowY: 'auto',
  },
};

const MetricProjectionWarningGroup = ({ messages, title }) => (
  <Flex vertical gap={4}>
    <Typography.Text strong>{title}</Typography.Text>
    {messages.map((text) => (
      <Typography.Text key={text}>{text}</Typography.Text>
    ))}
  </Flex>
);

MetricProjectionWarningGroup.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired,
};

const MetricProjectionWarningPopover = ({ warnings }) => {
  const fallbackMessages = getMetricProjectionFallbackMessages(warnings);
  const ratioConflictMessages = getMetricRatioConflictMessages(warnings);
  const warningMessages = getMetricProjectionWarningMessages(warnings);
  if (
    fallbackMessages.length === 0 &&
    ratioConflictMessages.length === 0 &&
    warningMessages.length === 0
  ) {
    return null;
  }

  return (
    <Popover
      content={
        <Flex vertical gap="middle">
          {fallbackMessages.length > 0 && (
            <MetricProjectionWarningGroup
              messages={fallbackMessages}
              title="部分数据已按不摊分规则处理"
            />
          )}
          {ratioConflictMessages.length > 0 && (
            <MetricProjectionWarningGroup
              messages={ratioConflictMessages}
              title="部分比率已按最新数据取值"
            />
          )}
          {warningMessages.length > 0 && (
            <MetricProjectionWarningGroup
              messages={warningMessages}
              title="部分数据未参与指标计算"
            />
          )}
        </Flex>
      }
      placement="bottomLeft"
      styles={popoverStyles}
      title="数据质量提示"
      trigger="click"
    >
      <Button
        aria-label="查看数据质量告警"
        icon={<InfoCircleOutlined />}
        type="text"
        title="查看数据质量告警"
        variant="text"
      />
    </Popover>
  );
};

MetricProjectionWarningPopover.propTypes = {
  warnings: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      count: PropTypes.number,
      metricId: PropTypes.string,
      metricName: PropTypes.string,
      reason: PropTypes.string,
    }),
  ),
};

MetricProjectionWarningPopover.defaultProps = {
  warnings: [],
};

export default MetricProjectionWarningPopover;
